<template>
  <div class="items-center topListActions">
    <create-new-btn v-if="!isUndefined(btnTitle)" :title="btnTitle" :click="btnClick"/>
    <search v-if="!isUndefined(updateSearchQuery)" @updateSearchQueryMethod="updateSearchQuery"/>
    <items-per-page v-if="!isAnyUndefined([itemsLength, currentPage, itemsLength])"
    :itemsLength="itemsLength" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @newItemsPerPage="newItemsPerPage"/>
  </div>
</template>

<script>
import createNewBtn from './createNewBtn.vue';
import search from './search.vue';
import itemsPerPage from './itemsPerPage.vue';

export default {
  components: {
    createNewBtn,
    search,
    itemsPerPage,
  },
  props: {
    btnTitle: String,
    btnClick: Function,
    itemsLength: Number,
    currentPage: Number,
    itemsPerPage: Number,
    updateSearchQuery: String,
  },
  methods: {
    updateSearchQueryMethod(searchQuery) {
      this.$emit('updateSearchQuery', searchQuery);
    },
    newItemsPerPage(newItemsPerPage) {
      this.$emit('newItemsPerPage', newItemsPerPage);
    },
  },
}
</script>

<style lang="css" scoped>
.topListActions {
  margin-bottom: 15px;
  width: 100%;
}
</style>
